import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {AuthService} from "../../../services/auth.service";
import {ApiService} from "../../api.service";
import {IGetWorkoutsPayload} from "./data/IGetWorkoutsPayload";
import {IGetWorkoutsResponse} from "./data/IGetWorkoutsResponse";
import {IWorkout} from "../../../../shared/interfaces/IWorkout";
import {IWorkoutPayload} from "../../../../features/workouts/workout-form/workout-form.component";
import {map} from "rxjs/internal/operators";
import {_pt} from "../../../services/preview-text/helpers/preview-text.function";

@Injectable({
  providedIn: "root",
})
export class WorkoutsControllerService {
  private readonly _resourceUrl: string = "/workouts";

  constructor(private apiService: ApiService) {}

  getWorkouts(payload: IGetWorkoutsPayload): Observable<IGetWorkoutsResponse> {
    return this.apiService.get<IGetWorkoutsResponse>(
      `${this._resourceUrl}`,
      payload,
      AuthService.defaultTokenHeader().headers,
    ).pipe(map(res => {
      res.data.forEach(w => {
        w.name = w.name.replace('Workout', _pt('workout_title'))
        w.name = w.name.replace('workout', _pt('workout_title').toLowerCase())
        w.name = w.name.replace('Protocol', _pt('workout_title'))
        w.name = w.name.replace('protocol', _pt('workout_title').toLowerCase())
      })
      return res;
    }));
  }

  getWorkout(workoutId: string): Observable<IWorkout> {
    return this.apiService.get<IWorkout>(
        `${this._resourceUrl}/${workoutId}`,
        {},
        AuthService.defaultTokenHeader().headers,
    ).pipe(map(workout => {
      workout.playlists.forEach(playlist => {
        playlist.playlistConfigs.forEach((config, index) => {
          config.order = index;
        })
      })
      return workout;
    }));
  }

  editWorkout(id: string, newWorkout: IWorkoutPayload): Observable<null> {
    const locationId =  AuthService.getSelectedLocationId();
    return this.apiService.put<null>(
        `${this._resourceUrl}`,
        {
          ...newWorkout,
          id
        },
        { locationId },
        AuthService.defaultTokenHeader().headers,
    );
  }


  createWorkout(newWorkout: IWorkoutPayload): Observable<null> {
    const locationId =  AuthService.getSelectedLocationId();
    return this.apiService.post<null>(
        `${this._resourceUrl}`,
        newWorkout,
        { locationId },
        AuthService.defaultTokenHeader().headers,
    );
  }

  toggleWorkoutStatus(workoutId: string, newStatus: boolean): Observable<any> {
    return this.apiService.patch(
        `${this._resourceUrl}/${workoutId}/toggle-active`,
        {},
        {
          isActive: newStatus
        },
        AuthService.defaultTokenHeader().headers,
    );
  }

}
